import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMe } from '../../hooks/useAuth';
import type { RootState } from '../../store/store';

interface AdminGuardProps {
  children: React.ReactNode;
}

/**
 * 관리자 권한 체크 컴포넌트
 * ProtectedRoute 내부에서 사용되어야 함 (로그인 여부는 이미 확인된 상태라고 가정)
 */
export default function AdminGuard({ children }: AdminGuardProps) {
  const { user: authUser } = useSelector((state: RootState) => state.auth);
  const { data: apiUser, isLoading } = useMe();
  
  // 로딩 중일 때는 리다이렉트 하지 않고 대기 (또는 로딩 표시)
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg-main)]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[var(--action-primary)]"></div>
      </div>
    );
  }

  // API 데이터 우선 사용, 없으면 Redux 데이터 사용
  const user = apiUser || authUser;
  
  // 관리자 권한 확인 (User 타입에 role이 있다고 가정)
  // AdminDashboard.tsx의 로직 참조: ['PLATFORM_ADMIN', 'ADMIN', 'SUPER_ADMIN']
  const userRole = (user as any)?.role || '';
  const isAdmin = ['PLATFORM_ADMIN', 'ADMIN', 'SUPER_ADMIN'].includes(userRole);

  if (!isAdmin) {
    // 관리자가 아니면 홈으로 리다이렉트
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
